<span mat-dialog-close class="close-button">
  <em class="icon-salir"></em>
</span>

<h2 mat-dialog-title>
  {{ titleText }}
</h2>
<div class="mat-dialog-content-wrapper">
  <div mat-dialog-content>
    <picture>
      <img [src]="srcImg" alt="" />
    </picture>
    <!-- solo cédula -->
    <ul
      *ngIf="
        data.attachId &&
        !data.attachWorkDocuments &&
        !data.attachIndependentDocuments
      "
    >
      <li>
        Sube archivos con formato <strong>JPG</strong> o
        <strong>PNG</strong> que no tengan un peso mayor a 3 MB.
      </li>
      <li>
        Ten en cuenta que no se vean brillos o sombras y que la información sea
        legible.
      </li>
    </ul>
    <!-- solo documentos -->
    <ul
      *ngIf="
        !data.attachId &&
        (data.attachWorkDocuments || data.attachIndependentDocuments)
      "
    >
      <li>
        Sube archivos con formato <strong>PDF</strong>, <strong>JPG</strong> o
        <strong>PNG</strong> que no tengan un peso mayor a 3 MB.
      </li>
      <li>
        Ten en cuenta que no se vean brillos o sombras y que la información sea
        legible.
      </li>
    </ul>
    <!-- documentos y cédula -->
    <ul
      *ngIf="
        data.attachId &&
        (data.attachWorkDocuments || data.attachIndependentDocuments)
      "
    >
      <li>
        La cédula puedes subirla en formato <strong>JPG</strong> o
        <strong>PNG</strong> y el resto de documentos en <strong>PDF</strong>,
        <strong>JPG</strong> o <strong>PNG</strong>.
      </li>
      <li>Los archivos no pueden tener un peso mayor a 3 MB.</li>
      <li>
        Ten en cuenta que no se vean brillos o sombras y que la información sea
        legible.
      </li>
    </ul>
  </div>
  <div class="opacity-box"></div>
</div>
<div mat-dialog-actions class="mat-dialog-actions">
  <button mat-dialog-close class="btn btn-degraded blue" type="button">
    Entendido
  </button>
</div>
